import { z } from 'zod'

// -------------------------------------------------------
// Contact Form Schema — shared between web (form) and api (validation)
// -------------------------------------------------------
export const contactSchema = z.object({
  name: z
    .string()
    .min(2, 'Name must be at least 2 characters')
    .max(100, 'Name must not exceed 100 characters')
    .trim(),

  email: z
    .string()
    .email('Please enter a valid email address')
    .max(255, 'Email must not exceed 255 characters')
    .toLowerCase()
    .trim(),

  subject: z
    .string()
    .min(3, 'Subject must be at least 3 characters')
    .max(150, 'Subject must not exceed 150 characters')
    .trim(),

  message: z
    .string()
    .min(10, 'Message must be at least 10 characters')
    .max(2000, 'Message must not exceed 2000 characters')
    .trim(),

  // Cloudflare Turnstile token — required on API, present on frontend
  turnstileToken: z.string().min(1, 'Security verification is required'),
})

export type ContactInput = z.infer<typeof contactSchema>


// -------------------------------------------------------
// API Response Schemas
// -------------------------------------------------------
export const apiSuccessSchema = z.object({
  success: z.literal(true),
  message: z.string(),
  alreadyRegistered: z.boolean().optional(),
})

export const apiErrorSchema = z.object({
  success: z.literal(false),
  error: z.string(),
  details: z.record(z.string(), z.unknown()).optional(),
})

export type ApiSuccess = z.infer<typeof apiSuccessSchema>
export type ApiError = z.infer<typeof apiErrorSchema>
export type ApiResponse = ApiSuccess | ApiError
